import React from 'react';

const Information = () => {
  return (
    <main className="flex-grow container mx-auto px-4 py-8">
      {/* Hero section */}
      <div className="bg-gradient-to-r from-purple-600 to-indigo-800 rounded-xl shadow-lg mb-12 p-8 text-white">
        <h1 className="text-3xl md:text-4xl font-bold mb-4">
          Válassza ki az Önnek megfelelő megoldást
        </h1>
        <p className="text-xl">
          Ismerje meg a különböző webes megoldásokat és válassza ki a vállalkozása számára legmegfelelőbbet
        </p>
      </div>

      {/* Megoldások grid */}
      <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3 mb-12">
        {/* Webshop megoldás */}
        <div className="bg-gradient-to-br from-purple-100 to-indigo-100 rounded-xl shadow-lg p-8 border border-purple-200">
          <div className="text-purple-600 mb-4">
            <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
            </svg>
          </div>
          <h2 className="text-2xl font-bold mb-4 text-purple-900">Webshop</h2>
          <div className="space-y-4 text-purple-900">
            <p>Ideális választás, ha:</p>
            <ul className="list-disc list-inside space-y-2">
              <li>Termékeket szeretne online értékesíteni</li>
              <li>Automatizált rendeléskezelést szeretne</li>
              <li>Raktárkészletet szeretne kezelni</li>
              <li>Online fizetési megoldásokat szeretne</li>
            </ul>
            <p className="font-semibold mt-4">Főbb funkciók:</p>
            <ul className="list-disc list-inside space-y-2">
              <li>Termékkezelés és kategóriák</li>
              <li>Kosár és pénztár folyamat</li>
              <li>Készletkezelés</li>
              <li>Rendeléskezelés</li>
              <li>Számlázási integráció</li>
            </ul>
          </div>
        </div>

        {/* Céges weboldal */}
        <div className="bg-gradient-to-br from-purple-100 to-indigo-100 rounded-xl shadow-lg p-8 border border-purple-200">
          <div className="text-purple-600 mb-4">
            <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
            </svg>
          </div>
          <h2 className="text-2xl font-bold mb-4 text-purple-900">Céges weboldal</h2>
          <div className="space-y-4 text-purple-900">
            <p>Ideális választás, ha:</p>
            <ul className="list-disc list-inside space-y-2">
              <li>Cégét szeretné bemutatni online</li>
              <li>Szolgáltatásait szeretné ismertetni</li>
              <li>Szakmai portfóliót szeretne</li>
              <li>Kapcsolatfelvételi lehetőséget szeretne</li>
            </ul>
            <p className="font-semibold mt-4">Főbb funkciók:</p>
            <ul className="list-disc list-inside space-y-2">
              <li>Reszponzív dizájn</li>
              <li>Szolgáltatások bemutatása</li>
              <li>Kapcsolati űrlap</li>
              <li>Referenciák megjelenítése</li>
              <li>Blog funkció (opcionális)</li>
            </ul>
          </div>
        </div>

        {/* Marketing megoldások */}
        <div className="bg-gradient-to-br from-purple-100 to-indigo-100 rounded-xl shadow-lg p-8 border border-purple-200">
          <div className="text-purple-600 mb-4">
            <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 3.055A9.001 9.001 0 1020.945 13H11V3.055z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.488 9H15V3.512A9.025 9.025 0 0120.488 9z" />
            </svg>
          </div>
          <h2 className="text-2xl font-bold mb-4 text-purple-900">Marketing megoldások</h2>
          <div className="space-y-4 text-purple-900">
            <p>Ideális választás, ha:</p>
            <ul className="list-disc list-inside space-y-2">
              <li>Online marketinget szeretne erősíteni</li>
              <li>Közösségi média jelenlétet építene</li>
              <li>Hirdetéseket szeretne kezelni</li>
              <li>Analitikai adatokat elemezne</li>
            </ul>
            <p className="font-semibold mt-4">Főbb funkciók:</p>
            <ul className="list-disc list-inside space-y-2">
              <li>Google Analytics integráció</li>
              <li>Social media menedzsment</li>
              <li>Hirdetéskezelés</li>
              <li>SEO optimalizálás</li>
              <li>Konverziókövetés</li>
            </ul>
          </div>
        </div>
      </div>

      {/* Felkészülési útmutató */}
      <div className="bg-gradient-to-br from-purple-100 to-indigo-100 rounded-xl shadow-lg p-8 border border-purple-200 mb-12">
        <h2 className="text-2xl font-bold mb-6 text-purple-900">Felkészülési útmutató</h2>
        
        <div className="grid md:grid-cols-2 gap-8">
          {/* Webshop előkészületek */}
          <div className="space-y-4">
            <h3 className="text-xl font-semibold text-purple-800">Webshop indításához szükséges:</h3>
            <ul className="list-disc list-inside space-y-2 text-purple-900">
              <li>Futárszolgálati szerződések (pl. FoxPost, GLS)
                <ul className="pl-6 mt-2 space-y-1 text-sm">
                  <li>• Árak és szállítási feltételek egyeztetése</li>
                  <li>• Csomagfeladási folyamat tisztázása</li>
                  <li>• API integráció lehetőségeinek felmérése</li>
                </ul>
              </li>
              <li>Számlázási szoftver kiválasztása
                <ul className="pl-6 mt-2 space-y-1 text-sm">
                  <li>• Online számlázó (pl. Billingo, Szamlazz.hu)</li>
                  <li>• NAV online számla beállítása</li>
                  <li>• Automatikus számlázás beállítása</li>
                </ul>
              </li>
              <li>Fizetési szolgáltatók
                <ul className="pl-6 mt-2 space-y-1 text-sm">
                  <li>• Bankkártyás fizetés (SimplePay, Barion)</li>
                  <li>• Banki átutalás feltételeinek meghatározása</li>
                  <li>• Utánvét kezelésének folyamata</li>
                </ul>
              </li>
              <li>Jogi dokumentumok
                <ul className="pl-6 mt-2 space-y-1 text-sm">
                  <li>• ÁSZF elkészítése</li>
                  <li>• Adatkezelési tájékoztató</li>
                  <li>• Szállítási és fizetési feltételek</li>
                  <li>• Cookie szabályzat</li>
                </ul>
              </li>
              <li>Termékadatok előkészítése
                <ul className="pl-6 mt-2 space-y-1 text-sm">
                  <li>• Professzionális termékfotók</li>
                  <li>• Részletes termékleírások</li>
                  <li>• Termék kategóriák kialakítása</li>
                  <li>• Árak és kedvezmények rendszere</li>
                </ul>
              </li>
            </ul>
          </div>

          {/* Általános előkészületek */}
          <div className="space-y-4">
            <h3 className="text-xl font-semibold text-purple-800">Minden weboldalhoz javasolt:</h3>
            <ul className="list-disc list-inside space-y-2 text-purple-900">
              <li>Arculati elemek
                <ul className="pl-6 mt-2 space-y-1 text-sm">
                  <li>• Logó (vektoros formátumban)</li>
                  <li>• Színkódok meghatározása</li>
                  <li>• Betűtípusok kiválasztása</li>
                  <li>• Meglévő marketing anyagok</li>
                </ul>
              </li>
              <li>Tartalom előkészítése
                <ul className="pl-6 mt-2 space-y-1 text-sm">
                  <li>• Cégbemutatkozó szöveg</li>
                  <li>• Szolgáltatások részletes leírása</li>
                  <li>• Referencia munkák fotói</li>
                  <li>• Csapatfotók, irodafotók</li>
                </ul>
              </li>
              <li>Domain és tárhely
                <ul className="pl-6 mt-2 space-y-1 text-sm">
                  <li>• Domain név kiválasztása és regisztrálása</li>
                  <li>• SSL tanúsítvány beszerzése</li>
                  <li>• Levelezés beállítása</li>
                </ul>
              </li>
              <li>Marketing előkészületek
                <ul className="pl-6 mt-2 space-y-1 text-sm">
                  <li>• Google Cégem profil létrehozása</li>
                  <li>• Közösségi média fiókok beállítása</li>
                  <li>• Google Analytics fiók létrehozása</li>
                  <li>• Remarketing pixelek előkészítése</li>
                </ul>
              </li>
            </ul>
          </div>
        </div>

        {/* Tippek és figyelmeztetések */}
        <div className="mt-8 space-y-4">
          <div className="p-4 bg-purple-50 rounded-lg border border-purple-200">
            <h4 className="font-semibold text-purple-900 mb-2">💡 Hasznos tippek:</h4>
            <ul className="space-y-2 text-purple-900">
              <li>• Készítsen ütemtervet az előkészületekhez</li>
              <li>• Gyűjtsön inspirációt más sikeres weboldalakról</li>
              <li>• Kérjen árajánlatot több szolgáltatótól is</li>
              <li>• Tervezze meg előre a termékfotózást</li>
              <li>• Gondolja át a raktározási és logisztikai folyamatokat</li>
            </ul>
          </div>
          
          <div className="p-4 bg-yellow-50 rounded-lg border border-yellow-200">
            <h4 className="font-semibold text-yellow-800 mb-2">⚠️ Mire figyeljen:</h4>
            <ul className="space-y-2 text-yellow-800">
              <li>• A jogi dokumentumok szakszerű elkészítése kulcsfontosságú</li>
              <li>• Minden szerződést alaposan olvasson el aláírás előtt</li>
              <li>• Tervezzen tartalék költségvetéssel</li>
              <li>• Készüljön fel a vevőszolgálat kezelésére</li>
              <li>• Gondolja át a termékvisszaküldés folyamatát</li>
            </ul>
          </div>
        </div>
      </div>

      {/* GYIK szekció */}
      <div className="bg-gradient-to-br from-purple-100 to-indigo-100 rounded-xl shadow-lg p-8 border border-purple-200 mb-12">
        <h2 className="text-2xl font-bold mb-6 text-purple-900">Gyakran Ismételt Kérdések</h2>
        
        <div className="space-y-6">
          {/* Fejlesztési időtartam */}
          <div className="p-4 bg-white/50 rounded-lg">
            <h3 className="text-xl font-semibold text-purple-900 mb-3">
              Fejlesztés megvalósításának tervezett kezdete és vége
            </h3>
            <div className="space-y-2 text-purple-800">
              <p>
                A fejlesztés kezdetét érdemes a pályázat pozitív elbírálását követő 2-3 héten belülre tervezni, 
                hogy legyen idő az alapos előkészítésre. A fejlesztés időtartama a projekt típusától függően változhat:
              </p>
              <div className="space-y-4 mt-4">
                <div className="p-3 bg-white/30 rounded-lg">
                  <h4 className="font-semibold mb-2">Egyszerűbb bemutatkozó weboldal (1-2 hét):</h4>
                  <ul className="list-disc list-inside space-y-1 text-sm">
                    <li>3-5 aloldal (Kezdőlap, Rólunk, Szolgáltatások, Kapcsolat)</li>
                    <li>Kapcsolati űrlap</li>
                    <li>Reszponzív dizájn (mobil és asztali nézet)</li>
                    <li>Alapszintű SEO beállítások</li>
                    <li>Google Térkép integráció</li>
                    <li>Social media linkek</li>
                  </ul>
                </div>

                <div className="p-3 bg-white/30 rounded-lg">
                  <h4 className="font-semibold mb-2">Közepes komplexitású webshop (3-4 hét):</h4>
                  <ul className="list-disc list-inside space-y-1 text-sm">
                    <li>Termékkezelő rendszer 50-200 termékkel</li>
                    <li>Kosár és pénztár folyamat</li>
                    <li>Online fizetési integráció</li>
                    <li>Szállítási módok beállítása</li>
                    <li>Automatikus számla generálás</li>
                    <li>Raktárkészlet kezelés</li>
                    <li>Akciók és kuponok kezelése</li>
                  </ul>
                </div>

                <div className="p-3 bg-white/30 rounded-lg">
                  <h4 className="font-semibold mb-2">Összetett rendszer egyedi funkciókkal (4-6 hét):</h4>
                  <ul className="list-disc list-inside space-y-1 text-sm">
                    <li>Egyedi jogosultsági rendszer</li>
                    <li>Többnyelvű tartalom</li>
                    <li>Komplex termékszűrők és keresés</li>
                    <li>Ügyfélfiók és rendelési előzmények</li>
                    <li>Blog rendszer</li>
                    <li>Hírlevél integráció</li>
                    <li>Automatizált marketing eszközök</li>
                    <li>Egyedi API integrációk</li>
                  </ul>
                </div>
              </div>
              <div className="mt-4 p-3 bg-purple-50 rounded-lg border border-purple-200">
                <p className="text-purple-900 font-medium">💡 Fontos tudni:</p>
                <ul className="mt-2 space-y-2 text-sm">
                  <li>• A megadott időtartamok a tényleges fejlesztési időt jelentik</li>
                  <li>• Az előkészítési fázis (tervezés, design) további 1-2 hetet vesz igénybe</li>
                  <li>• A tesztelés és finomhangolás az időtartam utolsó harmadában történik</li>
                  <li>• A tartalmak előkészítése (szövegek, képek) párhuzamosan zajlik</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Honlap fejlesztési igény */}
          <div className="p-4 bg-white/50 rounded-lg">
            <h3 className="text-xl font-semibold text-purple-900 mb-3">
              Mit érdemes feltüntetni a honlap fejlesztési igény pontban?
            </h3>
            <div className="space-y-2 text-purple-800">
              <p>
                A másfél milliós támogatási érték jogos felhasználásához az alábbi fejlesztési elemeket érdemes megjelölni:
              </p>
              <ul className="list-disc list-inside pl-4 space-y-2 mt-2">
                <li>Reszponzív webdesign (mobil, tablet és asztali nézet)</li>
                <li>Egyedi arculattervezés és UX design</li>
                <li>Tartalomkezelő rendszer (CMS) beépítése</li>
                <li>Keresőoptimalizálás (SEO) alapcsomag</li>
                <li>Többnyelvű verzió előkészítése</li>
                <li>Biztonsági funkciók és SSL tanúsítvány</li>
                <li>Kapcsolati űrlap spam védelemmel</li>
                <li>Google Analytics integrálása</li>
                <li>Social media integráció</li>
                <li>GDPR megfelelőség biztosítása</li>
              </ul>
              <div className="mt-4 p-3 bg-purple-50 rounded-lg border border-purple-200">
                <p className="text-purple-900 font-medium">💡 Tipp:</p>
                <p>
                  Érdemes kiemelni azokat a funkciókat, amelyek hosszú távon is értéket teremtenek a vállalkozás számára, 
                  például: automatizált marketing eszközök, ügyfélkezelés, vagy webshop funkciók.
                </p>
              </div>
              <div className="mt-4 p-3 bg-green-50 rounded-lg border border-green-200">
                <p className="text-green-900">
                  <span className="font-semibold">🤖 AI Asszisztens segítség:</span>
                </p>
                <p className="mt-2 text-green-800">
                  A fejlesztési igények professzionális megfogalmazásához használhatja a{' '}
                  <a 
                    href="https://chat.openai.com" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-green-700 hover:text-green-900 underline font-medium"
                  >
                    ChatGPT
                  </a>
                  {' '}vagy{' '}
                  <a 
                    href="https://chat.deepseek.com" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-green-700 hover:text-green-900 underline font-medium"
                  >
                    Deepseek
                  </a>
                  {' '}AI asszisztenseket. 
                  Példa prompt: "Írj egy részletes, szakmai fejlesztési igény leírást egy [típus] weboldalhoz, amely tartalmazza 
                  a következő funkciókat: [funkciók]. A leírás legyen alkalmas pályázati dokumentációhoz, és térjen ki a technikai 
                  részletekre is."
                </p>
                <div className="mt-3 text-sm text-green-700">
                  <p className="font-medium">Tippek az AI használatához:</p>
                  <ul className="list-disc list-inside space-y-1 mt-1">
                    <li>Adjon meg minél több részletet a vállalkozásáról</li>
                    <li>Sorolja fel az összes kívánt funkciót</li>
                    <li>Kérjen szakmai zsargont és magyarázatokat</li>
                    <li>Kérje a válasz többszöri finomítását</li>
                  </ul>
                </div>
                <div className="mt-4 p-3 bg-yellow-50/50 rounded border border-yellow-200 text-yellow-800">
                  <p className="font-medium">⚠️ Fontos figyelmeztetés:</p>
                  <p className="mt-1 text-sm">
                    Az AI eszközök csak segítséget nyújtanak a fogalmazásban. A generált szöveget minden esetben alaposan 
                    olvassa át, ellenőrizze a technikai részletek pontosságát, és szükség szerint módosítsa, hogy az 
                    tökéletesen illeszkedjen az Ön vállalkozásának egyedi igényeihez és a pályázati követelményekhez.
                  </p>
                </div>
              </div>
              <div className="mt-4 p-3 bg-blue-50 rounded-lg border border-blue-200">
                <p className="text-blue-900">
                  <span className="font-semibold">ℹ️ Megjegyzés:</span> A fenti funkciók részletes magyarázatát megtalálja 
                  az "Alapfogalmak és szolgáltatások" szekcióban lejjebb.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Alapfogalmak szekció */}
      <div className="bg-gradient-to-br from-purple-100 to-indigo-100 rounded-xl shadow-lg p-8 border border-purple-200 mb-12">
        <h2 className="text-2xl font-bold mb-6 text-purple-900">Alapfogalmak és szolgáltatások</h2>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* Tárhely és Domain */}
          <div className="space-y-4">
            <div className="text-purple-600">
              <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 12h14M5 12a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v4a2 2 0 01-2 2M5 12a2 2 0 00-2 2v4a2 2 0 002 2h14a2 2 0 002-2v-4a2 2 0 00-2-2m-2-4h.01M17 16h.01" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-purple-900">Tárhely és Domain</h3>
            <div className="space-y-2 text-purple-800">
              <p><span className="font-semibold">Tárhely:</span> A weboldal fájljainak és adatainak tárolására szolgáló online terület. Olyan, mint egy online "szekrény", ahol a weboldal minden eleme tárolódik.</p>
              <p><span className="font-semibold">Domain név:</span> A weboldal címe (pl. www.vallalkozas.hu). Ez az, amit a látogatók beírnak a böngészőbe, hogy elérjék az oldalt.</p>
            </div>
          </div>

          {/* Email szolgáltatások */}
          <div className="space-y-4">
            <div className="text-purple-600">
              <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-purple-900">Email szolgáltatások</h3>
            <div className="space-y-2 text-purple-800">
              <p><span className="font-semibold">Céges email:</span> Professzionális email címek a domain névvel (pl. info@vallalkozas.hu). Sokkal professzionálisabb megjelenést biztosít, mint az ingyenes szolgáltatók.</p>
              <p><span className="font-semibold">Email tárhely:</span> Az emailek és csatolmányok tárolására szolgáló terület. Meghatározza, mennyi emailt tud tárolni.</p>
            </div>
          </div>

          {/* Tervezési eszközök */}
          <div className="space-y-4">
            <div className="text-purple-600">
              <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-purple-900">Tervezési eszközök</h3>
            <div className="space-y-2 text-purple-800">
              <p><span className="font-semibold">Figma:</span> Modern webtervezési eszköz, amellyel a weboldal kinézetét tervezzük meg. Lehetővé teszi az interaktív prototípusok készítését.</p>
              <p><span className="font-semibold">Wireframe:</span> A weboldal vázlatos terve, amely megmutatja az elemek elrendezését és a főbb funkciókat.</p>
            </div>
          </div>

          {/* Adatbázisok */}
          <div className="space-y-4">
            <div className="text-purple-600">
              <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4m0 5c0 2.21-3.582 4-8 4s-8-1.79-8-4" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-purple-900">Adatbázisok</h3>
            <div className="space-y-2 text-purple-800">
              <p><span className="font-semibold">Adatbázis:</span> A weboldal dinamikus tartalmainak (termékek, felhasználók, rendelések) tárolására szolgáló rendszer.</p>
              <p><span className="font-semibold">MySQL:</span> Népszerű adatbázis-kezelő rendszer, amely lehetővé teszi az adatok strukturált tárolását és gyors elérését.</p>
            </div>
          </div>

          {/* Hosting szolgáltatások */}
          <div className="space-y-4">
            <div className="text-purple-600">
              <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-purple-900">Hosting szolgáltatások</h3>
            <div className="space-y-2 text-purple-800">
              <p><span className="font-semibold">Web hosting:</span> A weboldal "futtatására" szolgáló szolgáltatás. Biztosítja, hogy az oldal folyamatosan elérhető legyen az interneten.</p>
              <p><span className="font-semibold">SSL tanúsítvány:</span> Titkosítja a weboldal és a látogatók közötti kommunikációt, növelve a biztonságot.</p>
            </div>
          </div>

          {/* Fejlesztői eszközök */}
          <div className="space-y-4">
            <div className="text-purple-600">
              <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-purple-900">Fejlesztői eszközök</h3>
            <div className="space-y-2 text-purple-800">
              <p><span className="font-semibold">CMS:</span> Tartalomkezelő rendszer (pl. WordPress), amely lehetővé teszi a weboldal tartalmának egyszerű kezelését.</p>
              <p><span className="font-semibold">API:</span> Programozási interfész, amely lehetővé teszi különböző rendszerek (pl. webshop és futárszolgálat) összekapcsolását.</p>
            </div>
          </div>

          {/* Egyedi fejlesztés */}
          <div className="space-y-4">
            <div className="text-purple-600">
              <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 9l3 3-3 3m5 0h3M5 20h14a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-purple-900">Egyedi fejlesztés</h3>
            <div className="space-y-2 text-purple-800">
              <p><span className="font-semibold">Testreszabott megoldások:</span> Az Ön vállalkozásának egyedi igényeire szabott fejlesztés, amely pontosan illeszkedik a munkafolyamatokhoz.</p>
              <p><span className="font-semibold">Skálázhatóság:</span> A rendszer képes növekedni a vállalkozással együtt, új funkciók könnyen hozzáadhatók.</p>
            </div>
          </div>

          {/* Biztonsági beállítások */}
          <div className="space-y-4">
            <div className="text-purple-600">
              <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-purple-900">Biztonsági beállítások</h3>
            <div className="space-y-2 text-purple-800">
              <p><span className="font-semibold">Tűzfal védelem:</span> Védi a weboldalt a rosszindulatú támadásoktól és a nem kívánt behatolási kísérletektől.</p>
              <p><span className="font-semibold">Biztonsági mentések:</span> Rendszeres automatikus mentések a weboldal tartalmáról és adatbázisáról.</p>
            </div>
          </div>

          {/* SEO és Marketing */}
          <div className="space-y-4">
            <div className="text-purple-600">
              <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-purple-900">SEO és Marketing</h3>
            <div className="space-y-2 text-purple-800">
              <p><span className="font-semibold">Keresőoptimalizálás:</span> A weboldal láthatóságának növelése a Google és más keresőmotorok találati listáján.</p>
              <p><span className="font-semibold">Konverziókövetés:</span> A látogatók viselkedésének elemzése és a weboldal hatékonyságának mérése.</p>
            </div>
          </div>

          {/* Teljesítmény optimalizálás */}
          <div className="space-y-4">
            <div className="text-purple-600">
              <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-purple-900">Teljesítmény optimalizálás</h3>
            <div className="space-y-2 text-purple-800">
              <p><span className="font-semibold">Gyorsítótárazás:</span> A weboldal betöltési sebességének növelése a tartalmak okos tárolásával.</p>
              <p><span className="font-semibold">CDN használata:</span> Tartalom kiszolgáló hálózat, amely gyorsítja a weboldal elérését különböző földrajzi helyekről.</p>
            </div>
          </div>

          {/* Integrációk */}
          <div className="space-y-4">
            <div className="text-purple-600">
              <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-purple-900">Integrációk</h3>
            <div className="space-y-2 text-purple-800">
              <p><span className="font-semibold">Fizetési rendszerek:</span> Online bankkártyás fizetés, PayPal és egyéb fizetési módok integrálása.</p>
              <p><span className="font-semibold">Külső szolgáltatások:</span> Google Analytics, közösségi média, hírlevélküldő rendszerek bekötése.</p>
            </div>
          </div>

          {/* Karbantartás és támogatás */}
          <div className="space-y-4">
            <div className="text-purple-600">
              <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-purple-900">Karbantartás és támogatás</h3>
            <div className="space-y-2 text-purple-800">
              <p><span className="font-semibold">Rendszeres frissítések:</span> Biztonsági és funkcionalitási frissítések, hibajavítások.</p>
              <p><span className="font-semibold">Technikai támogatás:</span> Folyamatos segítségnyújtás és problémamegoldás.</p>
            </div>
          </div>

          {/* Webshop funkciók */}
          <div className="space-y-4">
            <div className="text-purple-600">
              <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-purple-900">Webshop funkciók</h3>
            <div className="space-y-2 text-purple-800">
              <p><span className="font-semibold">Kosárkezelés:</span> A vásárlók által kiválasztott termékek ideiglenes tárolása és kezelése a vásárlás során.</p>
              <p><span className="font-semibold">Készletkezelés:</span> A raktárkészlet automatikus követése és frissítése minden eladás után.</p>
            </div>
          </div>

          {/* Mobilbarát megoldások */}
          <div className="space-y-4">
            <div className="text-purple-600">
              <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-purple-900">Mobilbarát megoldások</h3>
            <div className="space-y-2 text-purple-800">
              <p><span className="font-semibold">Reszponzív dizájn:</span> A weboldal automatikusan alkalmazkodik minden képernyőmérethez (mobil, tablet, desktop).</p>
              <p><span className="font-semibold">PWA:</span> Progressive Web App - mobilalkalmazás-szerű élményt nyújtó webes technológia.</p>
            </div>
          </div>

          {/* Tartalom menedzsment */}
          <div className="space-y-4">
            <div className="text-purple-600">
              <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-purple-900">Tartalom menedzsment</h3>
            <div className="space-y-2 text-purple-800">
              <p><span className="font-semibold">WYSIWYG szerkesztő:</span> Egyszerű, szövegszerkesztő-szerű felület a tartalmak kezeléséhez.</p>
              <p><span className="font-semibold">Médiatár:</span> Képek, videók és dokumentumok rendszerezett tárolása és kezelése.</p>
            </div>
          </div>

          {/* Analitika és jelentések */}
          <div className="space-y-4">
            <div className="text-purple-600">
              <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 8v8m-4-5v5m-4-2v2m-2 4h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-purple-900">Analitika és jelentések</h3>
            <div className="space-y-2 text-purple-800">
              <p><span className="font-semibold">Látogatói statisztikák:</span> Részletes információk a weboldal forgalmáról, látogatók viselkedéséről.</p>
              <p><span className="font-semibold">Konverziók követése:</span> Értékesítések, regisztrációk és más fontos események mérése és elemzése.</p>
            </div>
          </div>

          {/* Automatizáció */}
          <div className="space-y-4">
            <div className="text-purple-600">
              <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-purple-900">Automatizáció</h3>
            <div className="space-y-2 text-purple-800">
              <p><span className="font-semibold">Email automatizáció:</span> Automatikus visszaigazolások, emlékeztetők és marketing üzenetek küldése.</p>
              <p><span className="font-semibold">Munkafolyamatok:</span> Ismétlődő feladatok automatizálása, például rendeléskezelés, számlázás.</p>
            </div>
          </div>

          {/* Jogi megfelelőség */}
          <div className="space-y-4">
            <div className="text-purple-600">
              <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-purple-900">Jogi megfelelőség</h3>
            <div className="space-y-2 text-purple-800">
              <p><span className="font-semibold">GDPR megfelelés:</span> Az európai adatvédelmi szabályozásnak megfelelő adatkezelés és tárolás.</p>
              <p><span className="font-semibold">Cookie kezelés:</span> Süti tájékoztató és kezelő rendszer a törvényi előírásoknak megfelelően.</p>
            </div>
          </div>

          {/* Felhasználói felület */}
          <div className="space-y-4">
            <div className="text-purple-600">
              <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16m-7 6h7" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-purple-900">Felhasználói felület</h3>
            <div className="space-y-2 text-purple-800">
              <p><span className="font-semibold">UX Design:</span> A felhasználói élmény tervezése, hogy az oldal könnyen használható és intuitív legyen.</p>
              <p><span className="font-semibold">UI Design:</span> A vizuális elemek (gombok, menük, színek) tervezése a márka arculatához igazítva.</p>
            </div>
          </div>

          {/* Keresőmotor optimalizálás */}
          <div className="space-y-4">
            <div className="text-purple-600">
              <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-purple-900">Keresőmotor optimalizálás</h3>
            <div className="space-y-2 text-purple-800">
              <p><span className="font-semibold">On-page SEO:</span> A weboldal tartalmának és struktúrájának optimalizálása a jobb keresési találatokért.</p>
              <p><span className="font-semibold">Technikai SEO:</span> A weboldal technikai beállításainak optimalizálása (sebesség, mobilbarát megjelenés, XML sitemap).</p>
            </div>
          </div>

          {/* Közösségi média integráció */}
          <div className="space-y-4">
            <div className="text-purple-600">
              <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8h2a2 2 0 012 2v6a2 2 0 01-2 2h-2v4l-4-4H9a1.994 1.994 0 01-1.414-.586m0 0L11 14h4a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2v4l.586-.586z" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-purple-900">Közösségi média integráció</h3>
            <div className="space-y-2 text-purple-800">
              <p><span className="font-semibold">Megosztási lehetőségek:</span> A weboldal tartalmának egyszerű megosztása különböző közösségi platformokon.</p>
              <p><span className="font-semibold">Social feed:</span> Közösségi média bejegyzések megjelenítése a weboldalon.</p>
            </div>
          </div>

          {/* Többnyelvűség */}
          <div className="space-y-4">
            <div className="text-purple-600">
              <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5h12M9 3v2m1.048 9.5A18.022 18.022 0 016.412 9m6.088 9h7M11 21l5-10 5 10M12.751 5C11.783 10.77 8.07 15.61 3 18.129" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-purple-900">Többnyelvű verzió</h3>
            <div className="space-y-2 text-purple-800">
              <p><span className="font-semibold">Mit tartalmaz?</span> A weboldal struktúrájának felkészítése több nyelv kezelésére, nyelvváltó menü.</p>
              <p><span className="font-semibold">Előnyök:</span> Később könnyedén bővíthető új nyelvekkel, nemzetközi piacok elérése.</p>
            </div>
          </div>

          {/* Fizetési megoldások */}
          <div className="space-y-4">
            <div className="text-purple-600">
              <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-purple-900">Fizetési megoldások</h3>
            <div className="space-y-2 text-purple-800">
              <p><span className="font-semibold">Bankkártyás fizetés:</span> Biztonságos online fizetési lehetőség a főbb kártyatípusok támogatásával.</p>
              <p><span className="font-semibold">Alternatív fizetési módok:</span> PayPal, utalás, utánvét és egyéb fizetési lehetőségek integrálása.</p>
            </div>
          </div>

          {/* Ügyfélszolgálat */}
          <div className="space-y-4">
            <div className="text-purple-600">
              <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8h2a2 2 0 012 2v6a2 2 0 01-2 2h-2v4l-4-4H9a1.994 1.994 0 01-1.414-.586m0 0L11 14h4a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2v4l.586-.586z" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-purple-900">Ügyfélszolgálat</h3>
            <div className="space-y-2 text-purple-800">
              <p><span className="font-semibold">Chat rendszer:</span> Azonnali segítségnyújtás a látogatóknak élő chat vagy chatbot segítségével.</p>
              <p><span className="font-semibold">Ticketing rendszer:</span> Ügyfélszolgálati kérések kezelése és nyomon követése.</p>
            </div>
          </div>

          {/* Reszponzív dizájn */}
          <div className="space-y-4">
            <div className="text-purple-600">
              <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-purple-900">Reszponzív webdesign</h3>
            <div className="space-y-2 text-purple-800">
              <p><span className="font-semibold">Mit jelent?</span> A weboldal automatikusan alkalmazkodik minden képernyőmérethez (mobil, tablet, laptop, asztali gép).</p>
              <p><span className="font-semibold">Miért fontos?</span> A látogatók több mint 60%-a mobilról böngészik, és a Google is előnyben részesíti a mobilbarát oldalakat.</p>
            </div>
          </div>

          {/* UX/UI Design */}
          <div className="space-y-4">
            <div className="text-purple-600">
              <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-purple-900">Arculattervezés és UX design</h3>
            <div className="space-y-2 text-purple-800">
              <p><span className="font-semibold">UX (User Experience):</span> A felhasználói élmény tervezése, hogy az oldal könnyen használható és intuitív legyen.</p>
              <p><span className="font-semibold">UI (User Interface):</span> A vizuális elemek (színek, gombok, menük) tervezése a márka arculatához igazítva.</p>
            </div>
          </div>

          {/* CMS */}
          <div className="space-y-4">
            <div className="text-purple-600">
              <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-purple-900">Tartalomkezelő rendszer (CMS)</h3>
            <div className="space-y-2 text-purple-800">
              <p><span className="font-semibold">Mit jelent?</span> Olyan felület, ahol programozói tudás nélkül is szerkesztheti weboldala tartalmát.</p>
              <p><span className="font-semibold">Előnyök:</span> Önállóan frissítheti a szövegeket, képeket, termékeket, árakat, és új oldalakat hozhat létre.</p>
            </div>
          </div>

          {/* SEO */}
          <div className="space-y-4">
            <div className="text-purple-600">
              <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-purple-900">Keresőoptimalizálás (SEO)</h3>
            <div className="space-y-2 text-purple-800">
              <p><span className="font-semibold">Alapcsomag tartalma:</span> Keresőbarát címek, meta leírások, képoptimalizálás, oldaltérkép készítése.</p>
              <p><span className="font-semibold">Cél:</span> A weboldal jobb helyezést érjen el a Google találati listáján a releváns keresésekre.</p>
            </div>
          </div>
        </div>
      </div>

      {/* Google Forms CTA */}
      <div className="bg-gradient-to-r from-purple-800 to-indigo-900 rounded-xl shadow-lg p-8 text-white text-center">
        <h2 className="text-2xl font-bold mb-4">Jelentkezzen most!</h2>
        <p className="mb-8 text-lg">
          Töltse ki jelentkezési űrlapunkat, és kollégáink hamarosan felveszik Önnel a kapcsolatot a részletekkel kapcsolatban.
        </p>
        <a 
          href="https://forms.gle/mfDWN7v71sycLqbz8"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block px-8 py-4 bg-white text-purple-900 rounded-lg font-semibold hover:bg-purple-100 transition-colors duration-200"
        >
          Jelentkezési űrlap megnyitása
        </a>
      </div>
    </main>
  );
};

export default Information; 